export default {"src":"/_next/static/media/business-icon-blue.1cbda24c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};